import React from "react";

import { templates } from "@reactivated";

import { WriteReviewSSR } from "../apps/reviews/WriteReviewSSR";

export const Template = (
    props: templates.WriteReviewTemplate,
): React.JSX.Element => {
    return <WriteReviewSSR {...props} />;
};
